/**
 * Chat List
 */
const chatData = [
    {
        image: 'assets/images/users/avatar-2.jpg',
        name: 'Jennie Sherlock',
        message: `Hey! there I'm available`,
        time: '02 min',
        color: 'secondary'
    },
    {
        image: 'assets/images/users/avatar-3.jpg',
        name: 'Stacie Dube',
        message: `I've finished it! See you so`,
        time: '10 min',
        color: 'success'
    },
    {
        image: 'assets/images/users/avatar-3.jpg',
        name: 'Katie Olson',
        message: 'This theme is awesome!',
        time: '22 min',
        color: 'success'
    },
    {
        image: 'assets/images/users/avatar-4.jpg',
        name: 'Marshall Wilson',
        message: 'Nice to meet you',
        time: '1 Hr',
        color: 'warning'
    },
    {
        name: 'James Lee',
        message: `Wow that's great`,
        time: '04 Hr',
        color: 'secondary'
    },
    {
        image: 'assets/images/users/avatar-5.jpg',
        name: 'Ronald Tucker',
        message: 'Nice to meet you',
        time: '22/04',
        color: 'success'
    },
    {
        image: 'assets/images/users/avatar-3.jpg',
        name: 'Katie Olsone',
        message: 'This theme is awesome!',
        time: '22 min',
        color: 'success'
    },
    {
        image: 'assets/images/users/avatar-4.jpg',
        name: 'Marshall Wilson',
        message: 'Nice to meet you',
        time: '01 Hr',
        color: 'success'
    },
];


/**
 * Chat Message List
 */
const chatMessagesData = [
    {
        name: 'Jennie Sherlock',
        message: 'Hello!',
        time: '10:00',
        profile: 'assets/images/users/avatar-2.jpg'
    },
    {
        align: 'right',
        name: 'Shawn',
        message: 'Hi, How are you? What about our next meeting?',
        time: '10:02',
        profile: 'assets/images/users/avatar-4.jpg'
    },
    {
        name: 'Jennie Sherlock',
        message: 'Yeah everything is fine',
        time: '10:06',
        profile: 'assets/images/users/avatar-2.jpg'
    },
    {
        name: 'Jennie Sherlock',
        message: '& Next meeting tomorrow 10.00AM',
        time: '10:06',
        profile: 'assets/images/users/avatar-2.jpg'
    },
    {
        align: 'right',
        name: 'Shawn',
        message: 'Wow that\'s great',
        time: '10:07',
        profile: 'assets/images/users/avatar-4.jpg'
    }
];

export { chatData, chatMessagesData };
